// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/e2e/[userId]/page"
import { usePageHead } from "../../../compat/head"

export const Route = createFileRoute("/e2e/$userId/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "PIC Dashboard" })
  const params = Route.useParams()
  const search = Route.useSearch()
  const pageProps: any = { params: Promise.resolve(params), searchParams: Promise.resolve(search) }
  return <Page {...pageProps} />
}
